export default __webpack_public_path__ + "static/media/excel2017.aec0f114.png";